import { REACTIONS, ReactionType } from "@/src/models/post.model";
import ReactionGlyph from "@/src/components/posts/reactions/reaction-glyph";
import { Like1 } from "iconsax-react-nativejs";
import { Animated, Pressable, Text } from "react-native";
import { useTheme } from "@/src/styles/theme-provider";

type LikeButtonProps = Readonly<{
  currentReaction: ReactionType;
  likeAnim: Animated.Value;
  size?: "sm" | "md";
  onPress: () => void;
  onLongPress: () => void;
  onHoverIn: () => void;
  onHoverOut: () => void;
}>;

const LIKE_REACTION = REACTIONS.find((rxn) => rxn.id === "like")!;

export const LikeButton = ({
  currentReaction,
  likeAnim,
  size = "md",
  onPress,
  onLongPress,
  onHoverIn,
  onHoverOut,
}: LikeButtonProps) => {
  const { themeVars } = useTheme();
  const iconSize = size === "sm" ? 14 : 18;
  const textClass = size === "sm" ? "text-xs" : "text-sm";
  const padding = size === "sm" ? "" : "p-2";

  const displayReaction =
    REACTIONS.find((rxn) => rxn.id === currentReaction) || LIKE_REACTION;

  return (
    <Pressable
      className={`rounded hover:bg-ash-3 flex-row items-center gap-1 ${padding}`}
      onPress={onPress}
      onLongPress={onLongPress}
      onHoverIn={onHoverIn}
      onHoverOut={onHoverOut}
    >
      <Animated.View style={{ transform: [{ scale: likeAnim }] }}>
        {currentReaction === "like" ? (
          <Like1 size={iconSize} color={LIKE_REACTION.color} variant="Bold" />
        ) : currentReaction ? (
          <ReactionGlyph id={displayReaction.id} size={size === "sm" ? 16 : 22} />
        ) : (
          <Like1 size={iconSize} color={themeVars["--color-slate-default"] as string} variant="Outline" />
        )}
      </Animated.View>
      <Text
        className={`${textClass} ${currentReaction ? "font-medium" : "font-normal"}`}
        style={{
          color: currentReaction ? displayReaction.color : themeVars["--color-slate-default"] as string,
        }}
      >
        {displayReaction.label}
      </Text>
    </Pressable>
  );
};

